export default __webpack_public_path__ + "static/media/m-s-bush-500x500.e79f8769.webp";